import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useRouteMatch } from "react-router-dom";
import { LogoPCB } from "../../assets/icons/stepsIcons/LogoPCB";
import LanguageSwitch from "../../shared/switchLanguages/LanguageSwitch";
import PBLogoKA from "../../components/piOnboarding/steps/icons/PBLogoKA";
import PBLogoEn from "../../components/piOnboarding/steps/icons/PBLogoEn";

const Header = () => {
  const history = useHistory();
  const [lang, setLang] = useState(null);
  const { i18n } = useTranslation();
  const shouldShowLangSwitch = useRouteMatch([
    "/agreement",
    "/creditinfo/agreement",
    "/ContactInfoChange/agreement",
    "/ibRegistration/agreement",
    "/ibservicechange/agreement",
    "/KYCform/agreement",
    "/Legal/agreement",
    "/identification/agreement",
  ]);
  const pathname = history.location.pathname;

  const isGeorgian = i18n.language === "ka";

  function changeLanguage(lang) {
    i18n.changeLanguage(lang);
    localStorage.setItem("culture", lang);
    setLang(lang);

    const pathParts = pathname.split("/");
    let langIndex = -1;
    for (let i = 0; i < pathParts.length; i++) {
      if (pathParts[i] === "en" || pathParts[i] === "ka") {
        langIndex = i;
        break;
      }
    }

    if (langIndex !== -1) {
      pathParts[langIndex] = lang;

      const currentUrl = new URL(window.location.href);
      const queryString = currentUrl.search;

      history.push(pathParts.join("/") + queryString);
    } else {
      console.warn("Language segment not found in URL");
    }
  }

  useEffect(() => {
    if (i18n.language) {
      setLang(i18n.language);
    } else if (localStorage.getItem("culture")) {
      setLang(localStorage.getItem("culture"));
    }
  }, [i18n]);

  const saveQueryString = (pathParam) => {
    return pathParam.split("?").unShift().join("?");
  };

  useEffect(() => {
    const splitPath = pathname.split("/");
    if (lang) {
      if (splitPath[splitPath.length - 1].startsWith("ka")) {
        if (splitPath[splitPath.length - 1].includes("?")) {
          const queryString = saveQueryString(splitPath[splitPath.length - 1]);
          splitPath[splitPath.length - 1] = lang + queryString;
        } else {
          splitPath[splitPath.length - 1] = lang;
        }
        history.push(splitPath.join("/"));
      } else if (splitPath[splitPath.length - 1].startsWith("en")) {
        if (splitPath[splitPath.length - 1].includes("?")) {
          const queryString = saveQueryString(splitPath[splitPath.length - 1]);
          splitPath[splitPath.length - 1] = lang + queryString;
        } else {
          splitPath[splitPath.length - 1] = lang;
        }
        history.push(splitPath.join("/"));
      }
    }
  }, [lang]);

  useEffect(() => {
    const splitPath = pathname.split("/");
    if (lang) {
      if (splitPath[splitPath.length - 1].startsWith("ka") && lang === "en") {
        i18n.changeLanguage("ka");
        setLang("ka");
      } else if (
        splitPath[splitPath.length - 1].startsWith("en") &&
        lang === "ka"
      ) {
        i18n.changeLanguage("en");
        setLang("en");
      }
    }
  }, [pathname]);

  return (
    <div className="flex justify-between mb-8">
      {isGeorgian ? <PBLogoKA /> : <PBLogoEn />}
      {shouldShowLangSwitch ? (
        <div className="right">
          <LanguageSwitch
            changeLanguage={changeLanguage}
            currentLanguageCode={lang}
          />
        </div>
      ) : null}
    </div>
  );
};

export default Header;
